import { createContext } from 'react'

const OfferCardSingleUnitCapacityContext = createContext(false)

export default OfferCardSingleUnitCapacityContext
